import * as actionTypes from '../types/qr';

const initialState = {
  listData: [],
  error: false,
  loading: false,
  storageData: [],
  okRequest: false,
  listDataQRTab: []
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.QR_DATA:
      return {
        ...state,
        error: false,
        loading: true
      };

    case actionTypes.QR_DATA_SUCCESS:
      return {
        ...state,
        listData: payload,
        error: false,
        loading: false
      };

    case actionTypes.QR_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    case actionTypes.QR_DATA_LIST:
      return {
        ...state,
        error: false
      };
    case actionTypes.QR_DATA_LIST_SUCCESS:
      return {
        ...state,
        error: false,
        listDataQRTab: payload,
        okRequest: true
      };
    case actionTypes.QR_DATA_LIST_FAIL:
      return {
        ...state,
        error: payload
      };

    case actionTypes.QR_DATA_UPDATE_STORAGE:
      return {
        ...state,
        storageData: payload
      };

    case actionTypes.QR_DATA_CLEAR:
      return {
        ...state,
        listData: []
      };

    case actionTypes.DELETING_PIECE:
      return {
        ...state,
        okRequest: false,
        error: false,
        loading: true
      };

    case actionTypes.DELETING_PIECE_SUCCESS:
      return {
        ...state,
        listData: payload,
        okRequest: true,
        error: false,
        loading: false
      };

    case actionTypes.DELETING_PIECE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    default:
      return state;
  }
};

export default reducer;
